export default ({
    className,
    children,
    active,
    onClick = e => e
}) => {
    if(active) 
        return (
            <div className={`green-button inactive ${className}`}>
                <div className="button-dots">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                </div>
            </div>
        )

    return (
        <div className={`green-button ${className}`} onClick={onClick}>
            {children}
        </div>
    );
}